import {useCallsStore} from "@/stores/callsStore";
import {useSDSStore} from "@/stores/sdsStore";
import {useGroupCallsStore} from "@/stores/groupCallsStore";
import {useContactsStore} from "@/stores/contactsStore";
import {notifyInfo, notifySuccess} from "@/services/toastService";
import {useICPStore} from "@/stores/icpStore";
import {useAuthStore} from "@/stores/authStores";

//import { useAuthStore } from "@/stores/authStores";

export function registerICPEvents(ICP) {
    const callsStore = useCallsStore();
    const sdsStore = useSDSStore();
    const groupCallsStore = useGroupCallsStore();
    const contactsStore = useContactsStore();


    const eventHandlers = {
        VoiceNotify: {
            OnDialInRinging: (data) => {
                console.log("Incoming call:", data);
                callsStore.receiveCall(data);
            },
            OnCallConnect: (data) => {
                console.log("On call connect:", data);
                callsStore.answerCall(data);
            },
            OnDialOutProceeding: (data) => {
                console.log("Outgoing call started:", data);
                callsStore.startNewCall(data);
            },
            OnCallRelease: (data) => {
                console.log("Call released:", data);
                callsStore.releaseCall(data);
            },
            OnDialOutFailure: (data) => {
                console.log("Dial out failure:", data);
                callsStore.releaseCall(data);
            },
            OnDialOutRinging: (data) => {
                console.log("Dial out ringing:", data);
                callsStore.updateCallStatus(data, "Ringing");
            },
            OnUserStatusNotify: (data) => {
                console.log("User status update:", data);
                contactsStore.updateContactsStatus(data.list);
            },
            OnHoldSuccess: (data) => {
                console.log("Call on hold:", data);
                callsStore.updateCallStatus(data, "Holding");
            },
            OnUnholdSuccess: (data) => {
                console.log("Call unheld:", data);
                callsStore.updateCallStatus(data, "Transmitting");

            },
            OnInterceptFailure: (data) => {
                console.log("Intercept failure:", data);
                notifyInfo("User is not in a call to intercept. Making new call instead.");
                useICPStore().ICP.dispatch.voice.dial({
                    "to": useContactsStore().getAllSelected[0].value.isdn,
                    "mikey": "",
                    "callback": (data) => {
                        console.log(data);
                    }
                })
            },
            OnInterceptSuccess: (data) => {
                console.log("Intercept failure:", data);
                notifySuccess("Called part intercepted successfully. Ready to talk.");
            }
        },

        MsNotify: {
            OnRecvDispSMSNotify: (data) => {
                console.log("Incoming SDS:", data);
                sdsStore.newMessage(data);
            },
            OnSendDispSMSResult: (data) => {
                console.log("SDS sent:", data);
                sdsStore.onMessageSent(data);
            }
        },

        ModuleNotify: {
            OnDisConnection: (data) => {
                console.log("SDK informing disconnection:", data);
                if (data.moduleType === "3") {   // Connection lost
                    useAuthStore().forceLogout("Connection to LTE server lost. Please check your network connection and try again.");
                } else if (data.moduleType === "4") { // SDK didn't initialize properly
                    useICPStore().eventData = {
                        stauts: "1",
                        desc: "SDK could not be initiated. Please make sure the MSP component is installed and running, and that there are no other instances of the app running and reload the page."
                    };
                } else if (data.moduleType === "5") { // User has been logged in elsewhere
                    useAuthStore().forceLogout("Forced logout: connection lost or user has been logged in from another device.");
                }

            },

            OnDispatchKickOutNotifyEvent: (data) => {
                console.log("User kicked out by the server:", data);
                useAuthStore().forceLogout("You have been kicked out by the server. Please log in again.");
            }
        },

        GroupCallNotify: {
            OnTalkingGroupCallPTTStart: (data) => {
                groupCallsStore.startCall(data);
            },
            OnTalkingGroupCallPTTIdle: (data) => {
                groupCallsStore.updateCallStatus(data);
            },
            OnTalkingGroupCallPTTNotify: (data) => {
                groupCallsStore.updateCallStatus(data);
            },
            OnGroupCallStatusNotify: (data) => {
                if (data.rsp === "4028") {
                    groupCallsStore.endCall(data);
                }
            },
            OnTalkingGroupEmergencyCallUp: (data) => {
                groupCallsStore.updateCallStatus(data);
            }
        },

        GroupNotify: {
            OnTalkingGroupMemberChange: (data) => {
                if (useGroupCallsStore().groupsConfigReady) {
                    console.log(data);
                    const grpId = data.groupinfo?.group;
                    groupCallsStore.reactToGroupChange(data);
                    var isPresetOrT2TOrPatch = (grpId === useGroupCallsStore().t2tGroupIsdn || grpId === useGroupCallsStore().patchGroupIsdn || useGroupCallsStore().presetGroupsIds.includes(grpId));
                    if (isPresetOrT2TOrPatch) {
                        groupCallsStore.handleDynamicRealignSuccess(data);
                    }
                }
            },

            OnTalkingGroupStatusChange: (data) => {
                console.info("ON Talking Group Status Change Event:", data);
                // check if this is coming from autocreate
                const loggedProfile = useAuthStore().loggedUserProfile;
                const groupNames = ["Main Line " + "(" + loggedProfile + ")", "T2T " + "(" + loggedProfile + ")", "Dynamic " + "(" + loggedProfile + ")"];
                if (groupNames.includes(data.groupinfo?.name) && data.opt === "create") {
                    // notify store about the new group created
                    groupCallsStore.handleGroupAutocreation(data.groupinfo?.group, data.groupinfo?.name);
                }
            },

            OnTalkingGroupMemberChangeFailure: (data) => {
                console.log(data)
                groupCallsStore.handleDynamicRealignFailure(data.value.grpid);
            }
        },

        MSPNotify: {
            OnSetVolumeResult: (data) => {
                console.log("volume update: ", data);
            }
        }
    };

    // Register all events
    Object.entries(eventHandlers).forEach(([eventType, handlers]) => {
        Object.entries(handlers).forEach(([eventName, callback]) => {
            console.log(`Registering event: ${eventType} / ${eventName}`);
            ICP.dispatch.event.register({
                eventType,
                eventName,
                callback
            });
        });
    });
}
